import { checkBrowserCookiesAllowed } from './handleCookies';

const storagedUrlProduct = () => {
  try {
    const cookiesAllowed = checkBrowserCookiesAllowed();
    const storagedItem = cookiesAllowed
      ? sessionStorage.getItem('appStudentsUrl')
      : window?.appStudentsUrl;
    if (process.env.REACT_APP_PRODUCT) {
      return process.env.REACT_APP_PRODUCT;
    }
    return storagedItem;
  } catch (err) {
    return false;
  }
};

const urlProduct = storagedUrlProduct() || window.document.referrer;

const urlParsed = urlProduct && new URL(urlProduct);

export default urlParsed ? urlParsed.hostname : 'not-specified';
